import { useQuery } from "react-query";
import apiEndPoints from "services/apiEndPoints";
import makeApiRequest from "services/makeApiRequest";
import createQueryParamsForGetReq from "helper/createQueryParamsForGetReq";

/*  we are fetching this api twice. for notifications and aslo for pagination. date is set undefined for getting all mails.In that we are checking for unread key and setting notification.
When user navigates threw arrow buttons to get previous date mails, we dont need to fetch that. Only current date mails and mails ith now date should be fetched.
  */
export default function UseGetInboxMails(date, is_read) {
  return useQuery(
    ["get-mails", is_read, date],
    async () => {
      const response = await makeApiRequest.get(
        createQueryParamsForGetReq(apiEndPoints.GET_INBOX_MAILS, {
          date: date,
          is_read: is_read,
        }),
      );
      return response.data;
    },

    // {
    //   refetchInterval: 3000,
    // }
  );
}
